import { createReducer } from 'lib/utilities.js';

const initialState = {
  new_visitors: [],
  lead_analytics: { mediums: [], medium_aggregates: [], test_data: [] },
  ranking_insights: {},
  rankings_group: null,
  ranking_insights_cards: [],
  leads_per_month: [],
  site_data: {
    adwords_id: null,
    adwords_mcc_id: null,
    amazon_integration: null,
    categories_id: null,
    category: null,
    client: {},
    client_id: null,
    dev_url: null,
    fb_ads_id: null,
    fb_page_id: null,
    fb_page_token: null,
    ga_account_id: null,
    ga_property_id: null,
    health: null,
    id: null,
    klaviyo_api_key: null,
    mailchimp_api_key: null,
    instagram_business_id: null,
    launch_date: null,
    live_url: null,
    name: null,
    public_hash: null,
    se_site_id: null,
    shopify_access_token: null,
    shopify_url: null,
    target_cost_per_conversion: null,
    twitter_username: null,
    wc_secret: null,
    wc_token: null,
  },
  analytics_insights: [],
  ranking_averages: [],
  percentage_of_keywords_in_top_ten: [],
  adwords_mtm: {},
  adwords_insights_cards: [],
};

const containsData = (data) => {
  if (data) {
    if (Array.isArray(data)) {
      if (data.length) {
        return data;
      }
      return null;
    }
  }
  return data;
};

export default createReducer(initialState, {
  FETCHING_NEW_VISITORS_SUCCESS: (state, payload) => ({
    ...state,
    new_visitors: containsData(payload),
  }),
  FETCHING_LEADS_ANALYTICS_SUCCESS: (state, payload) => ({
    ...state,
    lead_analytics: containsData(payload),
  }),
  FETCHING_RANKING_INSIGHTS_SUCCESS: (state, payload) => ({
    ...state,
    ranking_insights: { ...payload },
  }),
  FETCHING_LEADS_PER_MONTH_SUCCESS: (state, payload) => {
    const typesByMonthMap = (payload.typesByMonth || []).reduce((all, item) => {
      const stackKeys = Object.keys(item.value);
      all[item.name] = { ...item.value, stackKeys };
      return all;
    }, {});
    const withAddedTotalsByType = (payload.data || []).reduce((all, item) => {
      const mapReference = typesByMonthMap[item.name];
      if (mapReference) {
        all.push({ ...item, ...typesByMonthMap[item.name], stackNames: item.stackKeys });
      }
      return all;
    }, []);
    return {
      ...state,
      leads_per_month: containsData(withAddedTotalsByType),
    };
  },
  FETCHING_SITE_SUCCESS: (state, payload) => {
    const adwords_id = payload.adwords_id;
    const { client } = payload || {};
    const siteData = (client || {}).sites;
    let mailchimp_api_key = null;
    let instagram_business_id = null;

    if ((siteData || []).length) {
      mailchimp_api_key = (siteData[0] || {}).mailchimp_api_key;
      instagram_business_id = (siteData[0] || {}).instagram_business_id;
    }

    if (!adwords_id) {
      return {
        ...state,
        site_data: { ...payload, mailchimp_api_key, instagram_business_id },
        adwords_mtm: null,
      };
    }
    const final = {
      ...payload,
      mailchimp_api_key,
      instagram_business_id,
    };

    if (payload.adwords_mcc_id) {
      payload.adwords_id = undefined;
    }

    return {
      ...state,
      site_data: final,
    };
  },

  FETCHING_ANALYTIC_INSIGHTS_NEW_VISITORS_SUCCESS: (state, payload) => ({
    ...state,
    analytics_insights_new_visitors: containsData(payload),
  }),
  FORMAT_PERCENTAGE_OF_KEYWORDS_IN_TOP_TEN_SUCCESS: (state, payload) => ({
    ...state,
    percentage_of_keywords_in_top_ten: containsData(payload.data),
  }),
  FORMAT_RANKING_INSIGHTS_CARDS_SUCCESS: (state, payload) => {
    return {
      ...state,
      ranking_insights_cards: containsData(payload.data),
    };
  },
  FORMAT_RANKINGS_GROUP_SUCCESS: (state, payload) => ({
    ...state,
    rankings_group: payload.data,
  }),
  FORMAT_AVERAGE_POSITION_SUCCESS: (state, payload) => ({
    ...state,
    ranking_averages: containsData(payload.data),
  }),
  FETCHING_ADWORDS_MTM_SUCCESS: (state, payload) => {
    let adwords_insights_cards = state.adwords_insights_cards;
    if (payload.adwords_insights_cards.length > 0) {
      adwords_insights_cards = payload.adwords_insights_cards;
    }
    return {
      ...state,
      adwords_insights_cards,
      adwords_mtm: payload,
    };
  },

  // Failed states
  FETCHING_NEW_VISITORS_FAIL: (state, payload) => ({
    ...state,
    new_visitors: 'failed',
  }),

  FETCHING_LEADS_ANALYTICS_FAIL: (state, payload) => ({
    ...state,
    lead_analytics: 'failed',
  }),

  FETCHING_RANKING_INSIGHTS_FAIL: (state, payload) => ({
    ...state,
    ranking_insights: 'failed',
  }),

  FETCHING_LEADS_PER_MONTH_FAIL: (state, payload) => ({
    ...state,
    leads_per_month: 'failed',
  }),

  FETCHING_SITE_FAIL: (state, payload) => ({
    ...state,
    site_data: 'failed',
  }),

  FETCHING_ANALYTIC_INSIGHTS_NEW_VISITORS_FAIL: (state, payload) => ({
    ...state,
    analytics_insights_new_visitors: 'failed',
  }),

  FORMAT_AVERAGE_POSITION_FAIL: (state, payload) => ({
    ...state,
    ranking_averages: 'failed',
  }),

  FETCHING_RANKING_AVERAGES_FAIL: (state, payload) => ({
    ...state,
    ranking_averages: 'failed',
    ranking_insights_cards: 'failed',
    percentage_of_keywords_in_top_ten: 'failed',
  }),

  FETCHING_ADWORDS_MTM_FAIL: (state, payload) => ({
    ...state,
    adwords_insights_cards: 'failed',
    adwords_mtm: 'failed',
  }),
});
